import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 794.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,794.000000) scale(0.100000,-0.100000)">
<path d="M6765 6680 c-67 -3 -130 -11 -142 -18 -39 -22 -65 -71 -114 -215 -66
-196 -142 -418 -243 -711 -47 -137 -86 -252 -86 -257 0 -5 15 1 34 12 41 24
140 64 221 89 126 39 346 67 579 73 l88 2 58 155 c170 460 310 852 310 869 0
12 -427 13 -705 1z m-155 -844 c0 -2 -9 -6 -20 -9 -11 -3 -18 -1 -14 4 5 9 34
13 34 5z m20 -30 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0
10 -2 10 -4z"/>
<path d="M7703 6363 c-88 -17 -79 -182 10 -198 86 -16 152 68 115 147 -22 46
-64 63 -125 51z"/>
<path d="M8236 6270 c-52 -16 -96 -73 -96 -125 0 -19 -19 -44 -75 -97 -118
-112 -79 -102 -424 -108 l-304 -5 -18 -55 c-10 -30 -19 -61 -19 -68 0 -20 674
-13 710 7 14 8 67 55 117 104 l93 90 61 1 c57 1 63 3 96 40 34 36 35 41 31 98
-5 66 -26 95 -87 116 -38 14 -45 14 -85 2z"/>
<path d="M3750 6208 c0 -9 5 -20 10 -23 13 -8 13 5 0 25 -8 13 -10 13 -10 -2z"/>
<path d="M2400 6206 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M3767 6164 c-12 -13 -8 -35 13 -61 24 -31 25 -49 4 -70 -14 -14 -15
-12 -8 22 5 27 4 36 -5 31 -6 -4 -11 -2 -11 3 0 6 -9 11 -19 11 -15 0 -18 5
-14 23 l5 22 -21 -23 c-11 -13 -25 -21 -31 -17 -7 4 -9 -2 -5 -18 4 -14 2 -28
-4 -31 -6 -4 -11 0 -11 8 0 9 -4 16 -10 16 -5 0 -10 -8 -10 -17 0 -23 -59 -63
-92 -63 -14 0 -31 6 -38 14 -6 8 -17 12 -25 10 -7 -3 -15 3 -18 13 -4 16 -5
16 -6 1 -1 -15 -10 -18 -51 -18 l-50 0 0 -35 c0 -28 -3 -33 -17 -28 -11 5 -14
3 -8 -6 6 -10 0 -12 -24 -6 l-31 7 0 -50 c0 -53 -13 -68 -47 -55 -33 13 -41
26 -31 53 7 20 7 23 -3 13 -16 -15 -39 -17 -39 -3 0 6 7 10 15 10 8 0 15 4 15
8 0 4 -16 8 -35 8 -25 0 -35 -5 -35 -16 0 -22 -62 -63 -72 -47 -15 23 -8 -4
21 -81 16 -42 33 -90 38 -107 l10 -30 179 -6 c206 -6 320 -20 454 -55 188 -49
245 -75 255 -112 3 -13 8 -22 10 -20 6 6 -149 472 -193 581 -7 16 -12 34 -12
42 0 8 -4 17 -10 20 -5 3 -13 20 -18 36 -4 17 -11 27 -15 23z m-644 -309 c-3
-9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m-44 -35 c0 -10 -3 -8 -9
5 -12 27 -12 43 0 25 5 -8 9 -22 9 -30z m28 -22 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z"/>
<path d="M5384 6023 c4 -12 2 -24 -4 -28 -5 -3 -10 1 -10 9 0 30 -25 16 -42
-24 -15 -36 -20 -40 -52 -40 -42 0 -76 -28 -76 -64 0 -19 -7 -25 -35 -30 -20
-4 -40 -4 -45 -1 -6 4 -24 -1 -42 -9 -17 -9 -39 -16 -48 -16 -21 0 -72 -39
-52 -40 7 0 10 -5 7 -10 -4 -6 -11 -8 -16 -5 -5 4 -9 2 -9 -3 0 -5 -18 -14
-39 -21 -28 -8 -41 -18 -43 -33 -2 -15 -15 -26 -47 -36 -26 -9 -45 -22 -48
-33 -9 -32 -40 -23 -48 14 l-7 32 -15 -47 c-9 -27 -20 -48 -24 -48 -13 0 -11
13 7 49 17 34 13 57 -4 24 -10 -19 -222 -645 -222 -656 0 -4 24 9 54 28 153
98 281 137 449 139 62 1 111 -3 115 -9 4 -5 16 -15 27 -21 24 -13 31 -49 15
-78 -10 -19 -20 -21 -123 -22 -136 0 -196 -14 -307 -68 -69 -33 -102 -59 -180
-136 -53 -52 -120 -121 -149 -153 -86 -96 -180 -123 -319 -93 -88 18 -161 54
-308 151 -61 40 -135 80 -164 89 -47 14 -142 16 -727 16 l-674 0 -25 28 -25
27 22 -32 c18 -26 30 -33 58 -34 29 0 32 -2 16 -9 -18 -8 -18 -9 6 -9 14 -1
34 -7 45 -15 18 -14 18 -15 1 -21 -30 -12 -21 -43 16 -48 17 -3 -12 -4 -65 -3
-54 1 -95 -1 -90 -5 4 -4 302 -11 664 -15 l656 -7 33 -86 c18 -47 36 -88 39
-91 4 -3 9 -13 13 -22 4 -12 12 -15 23 -11 16 6 16 7 0 18 -9 7 -16 16 -16 20
0 5 9 0 19 -9 11 -10 17 -24 14 -32 -6 -17 13 -19 21 -1 3 6 3 2 0 -10 -3 -16
2 -25 19 -35 97 -53 166 -86 192 -92 29 -6 30 -9 27 -51 -4 -48 -10 -51 -81
-47 -53 3 20 -28 127 -53 80 -19 169 -19 269 0 101 19 172 48 255 103 97 64
161 133 231 251 73 122 113 164 187 199 45 21 70 26 136 26 69 0 87 -4 125
-26 79 -46 87 -63 229 -488 40 -118 76 -219 80 -224 15 -15 151 66 216 130 79
78 121 144 164 254 39 100 51 240 30 331 -11 46 -356 1093 -405 1229 -17 46
-33 72 -21 33z m20 -79 c3 -8 2 -12 -4 -9 -6 3 -10 -4 -10 -16 0 -12 -3 -20
-6 -16 -6 6 3 57 10 57 2 0 7 -7 10 -16z m13 -56 c-3 -8 -6 -5 -6 6 -1 11 2
17 5 13 3 -3 4 -12 1 -19z m-130 -145 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2
-7 2 -21 0 -30z m-384 -177 c7 -17 -2 -56 -13 -56 -33 0 -55 42 -33 63 11 12
41 7 46 -7z m-204 -250 c27 -29 22 -56 -14 -80 -14 -9 -25 -13 -25 -9 0 5 -10
13 -22 18 -15 6 -24 21 -26 38 -7 57 46 77 87 33z m772 -68 c4 -36 -11 -58
-38 -58 -15 0 -28 44 -18 59 9 15 55 14 56 -1z m-2928 -515 c-7 -2 -21 -2 -30
0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z"/>
<path d="M2348 5933 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M2560 5931 c0 -5 35 -9 77 -9 46 -1 79 -5 81 -11 2 -6 24 -11 48 -11
24 0 44 -3 44 -7 -1 -20 -19 -32 -55 -36 l-40 -4 42 -1 c23 -1 45 3 48 9 4 6
13 8 20 5 9 -3 11 2 8 17 l-5 22 20 -22 c11 -12 22 -19 26 -16 3 4 6 -1 6 -10
0 -13 -14 -17 -77 -20 l-78 -4 83 1 c45 1 82 -2 82 -6 0 -4 -75 -9 -167 -11
l-168 -3 176 -2 177 -2 -14 38 c-7 20 -13 44 -14 52 0 8 -5 22 -10 30 -9 13
-11 13 -20 0 -6 -10 -10 -11 -10 -2 0 9 -35 12 -140 12 -77 0 -140 -4 -140 -9z
m265 -11 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z"/>
<path d="M8852 5925 c-18 -8 -40 -28 -50 -45 -17 -30 -17 -30 -109 -30 l-92 0
-118 -119 -118 -118 -100 -7 c-55 -3 -225 -6 -378 -6 -287 1 -334 -5 -389 -42
-22 -15 -47 -18 -167 -18 l-140 0 -20 -62 c-10 -35 -17 -66 -14 -70 2 -4 86
-6 186 -4 185 4 229 11 276 48 22 17 50 18 397 18 211 0 384 4 398 10 13 5 77
62 142 126 l116 116 64 6 c50 4 69 1 90 -13 53 -35 134 -17 172 38 33 49 29
95 -10 141 -39 43 -85 54 -136 31z"/>
<path d="M2280 5591 c-116 -5 -109 -6 110 -11 221 -5 231 -6 160 -16 -53 -8
-64 -12 -37 -13 21 0 49 -8 62 -17 13 -9 30 -14 37 -11 8 3 6 6 -5 6 -10 1
-15 6 -12 11 3 6 -4 11 -17 12 -13 0 -3 4 22 7 50 7 69 3 49 -10 -10 -6 -7 -9
11 -9 15 0 31 -5 37 -11 6 -6 30 -12 52 -13 22 -1 44 -6 48 -10 9 -9 -35 -45
-57 -47 -8 -1 3 -5 25 -10 38 -7 37 -8 -12 -5 -29 2 -50 -1 -47 -6 3 -4 62 -9
132 -10 l127 -2 -130 -6 -130 -5 177 -5 c202 -6 184 -15 150 83 l-16 47 -135
0 c-126 0 -140 2 -191 27 -48 23 -69 26 -170 28 -63 1 -171 -1 -240 -4z m663
-148 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z"/>
<path d="M2540 5521 c23 -7 23 -8 5 -13 -16 -4 -16 -5 3 -3 12 1 25 -2 28 -6
3 -5 11 -9 17 -9 7 0 1 9 -13 20 -14 11 -34 19 -45 19 -16 -1 -15 -2 5 -8z"/>
<path d="M2458 5503 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3177 5504 c-3 -5 9 -47 26 -94 l32 -85 215 -5 c199 -5 221 -8 290
-32 41 -14 114 -38 161 -52 153 -47 221 -89 234 -146 4 -16 10 -30 15 -30 5 0
5 12 0 28 -51 170 -74 234 -90 255 -11 14 -20 36 -21 49 0 21 -1 22 -8 3 -5
-11 -7 -23 -4 -27 8 -14 -15 -8 -69 16 -101 45 -257 87 -395 106 -107 15 -379
24 -386 14z"/>
<path d="M6780 5503 c-92 -6 -208 -25 -300 -48 -100 -26 -326 -109 -348 -129
-16 -15 -85 -207 -77 -215 3 -3 9 -1 13 5 17 26 178 99 347 157 l120 42 221 3
222 3 31 86 c17 47 31 89 31 94 0 8 -156 10 -260 2z"/>
<path d="M2538 5480 c23 -5 48 -12 55 -16 9 -5 9 -4 1 5 -6 7 -31 14 -55 17
l-44 3 43 -9z"/>
<path d="M2668 5453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2678 5423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2365 5254 l-30 -13 30 6 c32 6 41 11 34 17 -2 2 -17 -2 -34 -10z"/>
<path d="M7783 5258 c-12 -6 -29 -26 -38 -44 l-16 -34 -162 -1 c-89 -1 -245
-5 -347 -8 l-185 -7 120 -4 c104 -4 109 -4 43 -7 -43 -2 -78 -8 -78 -13 0 -6
-5 -9 -12 -8 -7 2 -12 -7 -13 -20 0 -13 -9 -30 -19 -38 -18 -13 -12 -14 55
-16 70 -2 68 -2 -31 -8 -75 -4 -19 -7 200 -10 402 -5 548 -1 582 16 76 39 84
150 14 193 -36 23 -78 26 -113 9z"/>
<path d="M8344 5245 c-42 -21 -55 -34 -77 -79 -16 -33 -27 -72 -27 -96 0 -23
-6 -47 -12 -53 -7 -7 -51 -46 -97 -87 l-83 -75 -567 -5 c-311 -3 -541 -7 -511
-9 30 -1 78 -6 105 -11 l50 -7 -42 -2 c-54 -1 -60 -27 -8 -37 67 -12 51 -25
-30 -24 -37 0 -39 -1 -21 -15 18 -14 12 -15 -64 -15 -46 0 -81 -2 -79 -4 10
-10 1185 -17 1210 -8 14 6 66 49 115 96 49 47 94 86 100 86 7 0 31 -9 55 -20
24 -11 59 -20 77 -20 52 0 138 47 175 96 l32 43 78 1 c68 0 82 -3 111 -25 80
-61 196 -6 196 94 0 47 -17 79 -52 101 -55 33 -104 25 -160 -27 -25 -23 -30
-24 -100 -18 l-73 8 -30 45 c-58 89 -171 117 -271 67z"/>
<path d="M2442 5244 c10 -10 20 -15 24 -12 3 4 -5 12 -18 18 -22 12 -22 12 -6
-6z"/>
<path d="M1868 5243 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2480 5180 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"/>
<path d="M2302 5160 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M2520 5161 c0 -11 5 -23 10 -26 7 -4 7 -12 0 -25 -16 -30 -12 -48 13
-53 12 -3 -22 -5 -76 -4 -54 1 -90 -1 -80 -5 10 -4 279 -11 598 -15 l580 -8
79 -40 c43 -21 88 -48 100 -60 12 -11 28 -24 36 -27 8 -3 42 -28 75 -55 134
-108 212 -144 333 -151 76 -4 92 -2 92 10 0 13 -75 232 -106 308 l-14 35 3
-31 c3 -31 2 -32 -47 -38 -49 -6 -57 -3 -231 85 -99 50 -202 97 -230 105 -40
11 -164 14 -592 14 -531 0 -543 0 -543 -19z m1107 -7 c-3 -3 -12 -4 -19 -1 -8
3 -5 6 6 6 11 1 17 -2 13 -5z m131 -59 c3 -13 -41 -12 -45 1 -2 5 7 9 19 9 13
-1 24 -5 26 -10z m-73 -35 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12
15 0z"/>
<path d="M1960 5150 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2490 5150 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M2311 5114 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2047 4966 c15 -13 30 -23 32 -20 5 4 -41 43 -52 44 -4 0 5 -11 20
-24z"/>
<path d="M5967 4841 c-4 -17 -3 -21 5 -13 5 5 8 16 6 23 -3 8 -7 3 -11 -10z"/>
<path d="M6023 4703 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"/>
<path d="M6705 4698 c-53 -18 -169 -76 -190 -95 -82 -75 -248 -156 -374 -183
-52 -11 -96 -22 -99 -25 -3 -2 0 -10 5 -17 6 -7 9 -22 7 -34 -6 -36 36 -47
123 -34 41 7 77 9 81 6 3 -3 -6 -6 -19 -6 -20 -1 -22 -2 -9 -13 16 -13 15 -54
-2 -74 -5 -7 -7 -16 -4 -22 3 -5 -2 -12 -12 -16 -15 -7 -14 -9 8 -15 43 -13
155 -11 231 5 115 24 119 28 157 130 66 179 142 393 142 399 0 8 -8 7 -45 -6z"/>
<path d="M4860 4667 c-42 -19 -103 -96 -149 -189 -46 -93 -202 -235 -331 -301
-192 -99 -479 -110 -668 -27 -25 11 -47 18 -49 16 -7 -7 17 -80 207 -626 45
-129 88 -257 96 -283 11 -34 22 -51 39 -57 22 -8 503 -16 510 -8 1 2 48 131
105 288 56 157 141 389 188 515 128 347 204 566 209 606 7 51 -24 79 -86 78
-25 0 -57 -5 -71 -12z"/>
<path d="M1805 4590 c-13 -5 2 -8 44 -9 35 0 62 1 60 3 -10 9 -86 13 -104 6z"/>
<path d="M8295 4587 c-48 -20 -74 -40 -102 -79 l-26 -38 -673 0 -673 0 -20
-55 c-12 -31 -21 -62 -21 -70 0 -13 92 -15 695 -15 l694 0 15 -29 c30 -58 117
-112 180 -110 37 0 102 26 138 55 97 77 88 242 -19 317 -46 33 -138 45 -188
24z"/>
<path d="M1948 4555 c17 -14 36 -25 43 -25 8 0 -3 11 -23 25 -20 14 -40 25
-43 25 -4 0 7 -11 23 -25z"/>
<path d="M2000 4504 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z"/>
<path d="M2011 4464 c-7 -8 -11 -16 -10 -17 2 -1 14 -8 26 -14 30 -17 44 -16
37 2 -4 8 -1 15 5 15 6 0 10 -13 9 -29 -1 -16 -5 -28 -8 -26 -4 2 -17 -14 -31
-35 -13 -22 -27 -40 -31 -40 -5 0 -8 -9 -8 -21 0 -17 2 -18 13 -7 8 7 16 20
19 28 4 13 93 15 706 11 388 -2 702 1 702 5 0 5 -10 37 -22 72 l-22 62 -666 0
c-505 0 -669 -3 -678 -12 -9 -9 -12 -8 -12 5 0 21 -11 21 -29 1z"/>
<path d="M1908 4253 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1935 4240 c-20 -13 -24 -20 -14 -20 18 0 71 39 54 40 -5 0 -23 -9
-40 -20z"/>
<path d="M5765 4188 l-20 -21 23 12 c12 6 22 16 22 21 0 13 -2 12 -25 -12z"/>
<path d="M7896 4189 c-19 -15 -26 -30 -26 -54 0 -24 7 -39 26 -54 33 -26 50
-26 92 -1 26 16 32 26 32 54 0 39 -37 76 -75 76 -12 0 -34 -9 -49 -21z"/>
<path d="M1838 4193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2233 4192 c-8 -5 2 -8 23 -8 40 0 64 -23 64 -59 0 -15 -10 -25 -35
-34 -19 -7 -39 -9 -45 -6 -5 3 -10 1 -10 -4 0 -22 61 -11 86 15 42 41 15 104
-45 104 -14 0 -32 -4 -38 -8z"/>
<path d="M5695 4113 c-77 -70 -184 -137 -260 -162 -145 -47 -318 -60 -482 -35
-36 6 -44 4 -49 -12 -3 -11 -12 -32 -19 -49 -24 -58 -26 -83 -8 -89 145 -44
409 -32 576 26 160 55 357 203 371 278 3 20 3 27 -2 17 -6 -15 -10 -12 -20 17
-14 38 -29 45 -51 24 -11 -11 -12 -9 -6 10 3 12 5 22 3 22 -2 -1 -25 -21 -53
-47z"/>
<path d="M2200 4126 c0 -14 4 -27 8 -30 5 -3 6 8 4 25 -5 35 -12 38 -12 5z"/>
<path d="M2232 4125 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M2738 4070 c-36 -11 -86 -47 -122 -88 -16 -18 -36 -32 -45 -30 -90
13 -135 -119 -59 -175 30 -22 76 -25 119 -6 16 6 29 12 29 13 0 0 9 26 19 56
15 45 25 59 57 77 39 22 43 23 448 23 363 0 407 2 402 15 -3 9 -13 40 -22 70
l-15 55 -392 -1 c-216 0 -404 -4 -419 -9z m-71 -202 c-3 -8 -6 -5 -6 6 -1 11
2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M6440 4063 c-48 -11 -105 -13 -215 -10 -82 2 -141 2 -130 -2 11 -3
21 -11 22 -17 1 -6 4 -23 7 -37 5 -28 -10 -54 -34 -58 -34 -6 -156 38 -195 71
-13 11 -15 10 -9 -3 14 -38 -226 -241 -328 -278 -21 -7 -38 -18 -38 -24 0 -7
9 -38 21 -71 11 -32 50 -142 85 -243 35 -102 68 -189 73 -194 14 -14 470 -9
500 6 20 10 37 47 98 222 132 373 223 636 223 646 0 11 2 11 -80 -8z m-270
-33 c-8 -5 -19 -10 -25 -10 -5 0 -3 5 5 10 8 5 20 10 25 10 6 0 3 -5 -5 -10z"/>
<path d="M6641 4018 c-12 -34 -21 -66 -21 -70 0 -4 186 -8 413 -8 l413 0 47
-30 c26 -16 47 -37 47 -47 0 -45 24 -83 64 -98 36 -15 43 -15 81 -1 53 21 80
64 70 113 -8 43 -49 83 -84 83 -18 0 -45 17 -84 54 -33 30 -72 57 -89 60 -17
3 -212 6 -433 6 l-403 0 -21 -62z"/>
<path d="M6050 4000 c-13 -8 -13 -10 2 -10 9 0 20 5 23 10 8 13 -5 13 -25 0z"/>
<path d="M6035 3960 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M3014 3706 c-78 -35 -101 -136 -46 -197 24 -27 38 -33 83 -37 48 -4
59 -1 86 22 l31 26 281 0 c318 0 294 -7 263 83 l-17 49 -259 -1 -259 -2 -32
31 c-37 36 -87 46 -131 26z"/>
<path d="M7105 3708 c-11 -7 -28 -22 -38 -35 l-18 -23 -269 0 -268 0 -18 -52
c-9 -29 -19 -59 -22 -65 -3 -10 58 -13 286 -13 l291 0 37 -25 c68 -46 160 -22
190 50 19 46 18 74 -6 112 -33 55 -114 80 -165 51z"/>
<path d="M5390 3379 c-53 -12 -146 -21 -245 -25 -136 -6 -180 -3 -294 15 -74
12 -135 20 -136 19 -2 -2 -15 -41 -29 -87 -20 -64 -24 -86 -15 -92 26 -16 240
-49 359 -55 133 -6 295 10 440 44 64 15 75 21 72 37 -4 33 -54 165 -61 164 -3
-1 -44 -10 -91 -20z"/>
<path d="M1960 2565 c0 -9 9 -41 19 -73 10 -31 74 -226 141 -432 68 -206 142
-433 166 -505 l42 -130 89 -3 88 -3 52 163 c29 90 69 218 89 286 34 111 54
150 54 105 0 -9 22 -87 49 -172 28 -86 64 -201 80 -256 17 -55 35 -106 39
-113 6 -9 32 -12 93 -10 l84 3 61 185 c34 102 112 340 174 530 61 190 118 362
126 383 8 20 14 42 14 47 0 6 -51 10 -128 10 l-129 0 -10 -42 c-9 -40 -33
-121 -115 -393 -17 -55 -43 -147 -58 -205 l-28 -105 -11 40 c-5 22 -17 65 -25
95 -8 30 -40 143 -71 250 -32 107 -67 232 -79 277 l-21 83 -56 0 -56 0 -32
-112 c-18 -62 -46 -156 -61 -208 -16 -52 -48 -168 -71 -258 -23 -89 -44 -160
-46 -158 -3 2 -14 40 -24 83 -11 43 -34 123 -51 178 -57 189 -85 280 -114 377
l-29 98 -122 0 c-104 0 -123 -2 -123 -15z"/>
<path d="M3822 2533 c-12 -27 -52 -127 -91 -223 -74 -188 -131 -329 -261 -645
-45 -110 -84 -210 -87 -222 -5 -23 -5 -23 119 -23 l123 0 38 100 c21 55 44
103 50 107 7 4 92 9 189 10 l177 2 20 -54 c12 -30 30 -80 42 -110 l20 -55 125
0 c72 0 124 4 124 10 0 9 -90 240 -182 465 -22 55 -64 161 -93 235 -30 74 -68
169 -85 210 -17 41 -45 112 -62 158 l-31 82 -57 0 -57 0 -21 -47z m109 -513
c17 -41 42 -103 55 -137 l24 -63 -111 0 c-110 0 -111 0 -106 23 6 27 100 257
104 254 1 -2 16 -36 34 -77z"/>
<path d="M4610 2000 l0 -580 120 0 120 0 0 250 0 250 175 0 175 0 0 -250 0
-250 120 0 120 0 0 580 0 580 -120 0 -120 0 0 -235 0 -235 -175 0 -175 0 0
235 0 235 -120 0 -120 0 0 -580z"/>
<path d="M6280 2570 c0 -11 -90 -240 -185 -470 -206 -496 -275 -671 -271 -679
2 -3 60 -5 128 -3 l124 3 40 101 c21 55 43 102 49 103 5 2 87 6 181 9 l171 6
44 -106 c24 -59 48 -108 54 -110 6 -3 63 -3 127 -2 l116 3 -43 110 c-45 118
-167 422 -217 545 -33 82 -125 313 -168 425 l-27 70 -62 3 c-39 2 -61 -1 -61
-8z m167 -746 c-2 -3 -52 -3 -110 -2 l-106 3 48 120 c26 66 51 129 55 140 6
16 20 -10 63 -118 30 -77 53 -141 50 -143z"/>
<path d="M7121 1999 l0 -581 307 4 c339 5 353 7 459 74 121 77 173 226 124
354 -28 74 -64 115 -126 145 -30 15 -55 29 -55 31 0 2 15 10 33 18 42 18 77
52 106 105 20 38 23 53 19 120 -7 121 -63 203 -177 260 -83 42 -161 51 -439
51 l-252 0 1 -581z m544 354 c77 -37 95 -149 35 -217 l-28 -31 -156 -3 -156
-3 0 135 0 136 135 0 c105 0 142 -4 170 -17z m18 -457 c54 -23 80 -59 84 -118
4 -60 -8 -91 -49 -121 -38 -28 -105 -36 -238 -30 l-115 6 -3 138 -4 139 147 0
c101 0 155 -4 178 -14z"/>
<path d="M3280 1068 c0 -40 3 -124 7 -185 l6 -113 81 1 c45 0 96 6 114 13 65
23 122 101 122 166 0 38 -24 95 -56 130 -41 45 -90 60 -198 60 l-76 0 0 -72z
m209 -37 c26 -24 31 -36 31 -75 0 -76 -42 -116 -121 -116 l-29 0 0 110 0 110
44 0 c35 0 50 -6 75 -29z"/>
<path d="M3961 1118 c-5 -13 -30 -75 -56 -138 -91 -222 -89 -215 -42 -214 54
2 56 3 62 38 7 33 9 34 58 38 78 6 92 1 103 -35 8 -29 13 -32 52 -35 51 -4 51
-8 0 113 -17 39 -46 112 -67 162 -35 90 -37 93 -69 93 -24 0 -35 -5 -41 -22z
m73 -186 c7 -20 4 -22 -28 -22 -41 0 -44 11 -20 68 l15 37 13 -31 c8 -17 17
-40 20 -52z"/>
<path d="M4360 1106 c0 -34 1 -35 48 -38 l47 -3 3 -147 3 -148 39 0 40 0 0
144 c0 159 -1 156 66 156 32 0 34 2 34 35 l0 35 -140 0 -140 0 0 -34z"/>
<path d="M4951 1103 c-8 -21 -24 -60 -37 -88 -31 -67 -94 -227 -94 -238 0 -4
19 -7 42 -5 37 3 43 6 50 34 9 34 33 44 108 44 41 0 55 -11 65 -53 6 -24 12
-27 51 -27 24 0 44 2 44 5 0 3 -18 47 -39 98 -22 50 -55 130 -73 177 -33 82
-35 85 -69 88 -32 3 -36 0 -48 -35z m65 -128 c20 -49 18 -55 -21 -55 -19 0
-35 5 -35 11 0 13 30 79 37 79 2 0 11 -16 19 -35z"/>
<path d="M5482 1120 c-36 -22 -52 -54 -52 -105 0 -42 32 -69 104 -90 72 -21
80 -28 72 -59 -5 -22 -12 -26 -43 -26 -19 0 -50 9 -68 20 l-32 20 -22 -24
c-13 -14 -20 -29 -16 -35 15 -26 86 -51 141 -51 50 0 59 3 90 34 28 28 34 42
34 75 0 48 -30 86 -77 97 -53 13 -104 44 -101 62 5 28 50 37 88 18 33 -16 34
-16 62 13 l29 30 -40 20 c-52 27 -125 27 -169 1z"/>
<path d="M5970 1008 c0 -107 3 -140 18 -168 50 -99 223 -97 272 5 17 35 20 61
20 168 l0 127 -40 0 -40 0 0 -115 c0 -123 -9 -157 -47 -174 -33 -15 -47 -14
-74 8 -22 18 -24 28 -29 148 l-5 128 -37 3 -38 3 0 -133z"/>
<path d="M6560 987 c0 -85 3 -169 6 -187 l7 -32 108 4 c101 3 110 5 135 29 38
39 43 97 11 135 -22 26 -23 32 -11 49 24 32 17 81 -15 117 -29 33 -30 33 -135
36 l-106 4 0 -155z m168 77 c16 -5 22 -14 22 -34 0 -31 -15 -40 -66 -40 -32 0
-34 2 -34 33 0 19 3 37 7 40 8 9 41 9 71 1z m37 -164 c3 -10 1 -28 -5 -40 -9
-16 -21 -20 -60 -20 l-50 0 0 40 0 40 54 0 c46 0 56 -3 61 -20z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
